import { Component, OnInit, Inject, NgModule, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MsisdnService } from '../msisdn.service';
import { NotificationsService, SimpleNotificationsModule, NotificationType } from 'angular2-notifications';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NgZone } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MasterService } from '../../../../../master.service';
import { Options } from 'angular2-notifications';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-msisdn',
  standalone: true,
  imports: [RouterModule, HttpClientModule, CommonModule, SimpleNotificationsModule, CommonModule, MatSelectModule, MatOptionModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule],
  templateUrl: './msisdn.component.html',
  styleUrl: './msisdn.component.scss'
})
export class MsisdnComponent implements OnInit {
  pageEvent: any;
  element: any = {};

  // Define notification options with the correct type
  notificationOptions: Options = {
    timeOut: 1000,             // Notification duration in ms
    showProgressBar: true,     // Show progress bar
    pauseOnHover: true,        // Pause timeout on hover
    clickToClose: true,
    position: ['top', 'right'],     // Close notification on click
  };

  msisdnRangeList: any = [];
  selection = new SelectionModel<any>(false, []);
  dataSource = new MatTableDataSource<any>();

  length = 100;
  pageSizeOptions = [5, 10, 25, 100];
  pageSize = 10;
  currentPage = 0;
  totalElements = 0;
  totalPages = 0;
  Math = Math;

  constructor(
    private notifications: NotificationsService,
    public masterService: MasterService,
    public msisdnService: MsisdnService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.element.searchKey = null;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.element.sortField = "rangeName";
    this.element.sortOrder = "asc";
    this.getList();
  }

  getList() {
    console.log("List called ", this.element);
    console.log("Service Object ", this.msisdnService);
    this.msisdnService.getMsisdnRangeByPagination(this.element).subscribe(data => {
      console.log("received data ", data);
      this.msisdnRangeList = data.content.content;
      this.totalElements = data.content.totalElements;
      this.totalPages = data.content.totalPages;
      this.length = this.totalElements;
      this.dataSource.data = this.msisdnRangeList;
      console.log("this.msisdnRangeList ", this.msisdnRangeList);
    });
  }

  editMsisdnRange(index: any) {
    console.log("editMsisdn called ");
    this.masterService.checkFeature('MASTER.MSISDN.MODIFY', '/masters/edit-msisdn/' + this.msisdnRangeList[index].id);
  }

  addMsisdnRange() {
    console.log("addMsisdn called ");
    this.masterService.checkFeature('MASTER.MSISDN.CREATE', '/masters/add-msisdn');
  }

  deleteMsisdnRange(index: any) {
    console.log("Select msisdn index  ", index);
    let msisdn = this.msisdnRangeList[index];
    console.log("Select msisdn ", msisdn);
    if (this.masterService.checkFeatureFound('MASTER.MSISDN.DELETE') == false) {
      console.log("No permission to delete!!");
      return;
    }
    this.msisdnService.delete(msisdn.id).subscribe(data => {
      console.log("Received delete data ", data);
      if (data.status != true) {
        console.log("Error While deleting msisdn ", data.responseDescription);
        this.notifications.error('Error', 'MSISDN Range delete failed!');
        return;
      } else {
        console.log("delete success ", data);
        this.notifications.success('Success', 'MSISDN Range deleted successfully!');
        this.getList();
      }
    },
    error => {
      console.log("msisdn Deleted Not successfully.", error);
      this.notifications.error('Error', 'MSISDN Range delete failed!');
    });
  }

  searchKey() {
    console.log("searchKey called ");
    if (this.element == null || this.element == undefined)
      return;
    this.msisdnService.searchKey(this.element).subscribe({
      next: (data) => {
        this.ngZone.run(() => {
          this.msisdnRangeList = data?.content.content || [];
        });
      },
      error: (err) => {
        console.error('Search error:', err);
      },
    });
  }

  clearSearch() {
    console.log("clearSearch called");
    if (this.element.searchKey != null) {
      this.element.searchKey = null;
      this.getList();
    }
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.getList();
  }
}
